import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';
import { connect } from 'react-redux';


function TicketLink({ ticket, children, className, linkSuffix, route, hideOnRouteMatch, ...props }) {
  if (!ticket || (_.isObject(ticket) && _.isEmpty(ticket))) return null;

  const ticketId = _.isObject(ticket) ? ticket.id : ticket;
  const ticketLink = `/tickets/${ticketId}${linkSuffix || '/summary'}`;

  if (hideOnRouteMatch && route.pathname === ticketLink) return null;

  const passed = _.omit(props, ['dispatch']);

  return (
    <Link to={ticketLink} className={classNames(className, 'ticket-link')} {...passed}>
      {children || ticket.description}
    </Link>
  );
}

TicketLink.propTypes = {
  ticket: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number
  ]).isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  linkSuffix: PropTypes.string,
  route: PropTypes.object.isRequired,
  // If true, the component will not render when user is already on the route which is being linked-to
  hideOnRouteMatch: PropTypes.bool
};

// Exports
export default connect((state) => ({
  route: state.location
}))(TicketLink);
